/*
 * types/services/dr2am.tasks.roles.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';
import {PbRole} from './PbRole';

/**
 * The ServiceListRolessResponse model module.
 * @module model/ServiceListRolessResponse
 * @version version not set
 */
export class ServiceListRolessResponse {
  /**
   * Constructs a new <code>ServiceListRolessResponse</code>.
   * @alias module:model/ServiceListRolessResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListRolessResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListRolessResponse} obj Optional instance to populate.
   * @return {module:model/ServiceListRolessResponse} The populated <code>ServiceListRolessResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListRolessResponse();
      if (data.hasOwnProperty('roles'))
        obj.roles = ApiClient.convertToType(data['roles'], [PbRole]);
      if (data.hasOwnProperty('next_page_token'))
        obj.nextPageToken = ApiClient.convertToType(data['next_page_token'], 'String');
      if (data.hasOwnProperty('total'))
        obj.total = ApiClient.convertToType(data['total'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbRole>} roles
 */
ServiceListRolessResponse.prototype.roles = undefined;

/**
 * @member {String} nextPageToken
 */
ServiceListRolessResponse.prototype.nextPageToken = undefined;

/**
 * @member {String} total
 */
ServiceListRolessResponse.prototype.total = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceListRolessResponse.prototype.state = undefined;


